import React, { useState, useEffect } from 'react';
import { Button } from '../ButtonElements';
import GetHeroVideo from './GetHeroVideo'
import backup from '../../videos/v2.mp4';

import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
  ModalButton
} from './HeroElements';
import BetaModal from '../BetaModal';

function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState({ fileUrl: '' });

  useEffect(() => {
    GetHeroVideo().then(vid => setVideo({ fileUrl: vid }));
  }, []);

  return (
    <HeroContainer id='home'>
      <HeroBg>
        <>
          {video.fileUrl == '' ? <VideoBg playsInline autoPlay loop muted src={backup} type='video/mp4' />
            : (<VideoBg playsInline autoPlay loop muted src={video.fileUrl} type='video/mp4' />)}
        </>
      </HeroBg>
      <HeroContent>
        <HeroH1>Stories We Feel</HeroH1>
        <HeroP>
          We all have stories that define us, a shared thread of commonality. The tales we were told as children evoke fond memories, guide us through adversity, and spark our imaginations. Now, it’s our turn to pass on those stories. What narratives will we weave for our own children? Cherish the moments by sharing your own journey.
        </HeroP>
        <HeroBtnWrapper>
          <ModalButton primary={true} big={false} fontBig={true} onClick={() => setIsModalOpen(true)}>
            Try Our Preview
          </ModalButton>
        </HeroBtnWrapper>
      </HeroContent>

      <BetaModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </HeroContainer>
  );
}

export default HeroSection;
